import React, { Component } from 'react';
import {
    Loading,SkeletonText, AccordingItem, TextInput, Accordion, AccordionItem, AccordionProps, AccordionSkeleton, Tile, DatePicker, DatePickerInput, Button, DataTable, DataTableCell, Table, TableHeader, TableHead, TableRow, TableContainer, TableBody, TableCell, InlineLoading
} from 'carbon-components-react';
import moment from 'moment';
import { NoRecordsPlaceholder } from '../../../../helpers/jsonschemaform/DataTableExtention';
import View16 from '@carbon/icons-react/lib/view/16';
import FileUpload from '../../../common/FileUpload';
import Save16 from '@carbon/icons-react/lib/save/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Close16 from '@carbon/icons-react/lib/close/16';
import { api, inspection,me } from '../../../../helpers/api/api';
import { v4 as uuid } from 'uuid';
import { IsEnabled, IsEditable, CanExecuteAction, IsInRole } from '../../../../helpers/authorization/Policies';
import SimpleReactValidator from 'simple-react-validator';
import { showNotification } from '../../../../helpers/notification/BaseNotification';
import {
  getError,
  sizeFormat,
  getSuccess,
  apioperation,
  entitiesLabels,
  STATUS
} from '../../../../helpers/Constants';
import { AppContext } from '../../../../helpers/context/AppContext';
export class InspectionInformation extends Component {

    constructor(props) {
        super(props);
        this.validations = new SimpleReactValidator();
        this.state = {
            attachments:this.props.inspectionInfo.inspectionReport?.attachments!=null ? this.props.inspectionInfo.inspectionReport?.attachments: [],
            isSubmitted: false,
            editingDisabled: false,
            checkstartDate:true
        };
        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.updateMainInformation = this.updateMainInformation.bind(this);
        this.renderLoadingModal = this.renderLoadingModal.bind(this);

    }



    renderLoadingModal = () => {
        const show = this.state.isSubmitted;
        return show && <Loading active withOverlay description="Saving..." />;
      };
    updateMainInformation = async () => {
        try {
            if (this.validations.allValid()) {
          this.setState({ isSubmitted: true, editingDisabled: true });
          await api.put('/inspection/maininformation', this.props.inspectionInfo);
        
          showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.INSPECTION, apioperation.PUT));
             } else {
            this.validations.showMessages();
            showNotification.warning(`${entitiesLabels.WARNING}`,
              `${entitiesLabels.NOTIFICATION} required fields are missing  `
            );
      
            this.forceUpdate();
          }
        } catch (error) {
          showNotification.error(`${entitiesLabels.ERROR}`,getError(entitiesLabels.INSPECTION, apioperation.PUT));
        } finally {
          this.setState({ isSubmitted: false , editingDisabled: false});
        }
      };
    onStartDateChange(e) {     
        this.props.onDateChange();
          var inspection =this.props.inspectionInfo.inspectionReport;
          inspection.startDate = moment(e[0]).format('YYYY-MM-DD');
          inspection.endDate = moment(e[1]).format('YYYY-MM-DD');
         if(inspection.startDate != null){
          this.setState({ checkstartDate: false });
         }
          return { inspection };
       
      }
     
    renderMainInformationTitle = () => {
        return (
            <>
                <>
                    <div className="bx--row">
                        <div className="bx--col-lg-3 bx--col-md-3 mainInformationReportAccordion">
                            <span className="mainInformationHeaderTitle">Main Information</span>
                        </div>
                    </div>
                    <div className="bx--row">
                        <div className="bx--col-lg-3 bx--col-md-2 mainInformationPadding">
                            {/* RITM0945977 */}
                            {/* <span className="bold">Division</span> */}
                            <span className="bold">Business Line</span>
                            <div className="bx--row">
                                <div className="bx--col-lg-12 bx--col-md-12 mainInformationPadding">
                                    {this.props.tabsLoading ? (
                                        <SkeletonText />
                                    ) : (
                                            <span className="font-small">{this.props.inspectionInfo.division}</span>
                                        )}
                                </div>
                            </div>
                        </div>
                        <div className="bx--col-lg-3 bx--col-md-2 mainInformationPadding">
                            <span className="bold">WorkSite</span>
                            <div className="bx--row">
                                <div className="bx--col-lg-12 bx--col-md-12 mainInformationPadding">
                                    {this.props.tabsLoading ? (
                                        <SkeletonText />
                                    ) : (
                                            <span className="font-small">
                                                {this.props.inspectionInfo.workSite}
                                            </span>
                                        )}
                                </div>
                            </div>
                        </div>
                        <div className="bx--col-lg-3 bx--col-md-2 mainInformationPadding">
                            <span className="bold">Inspection Section</span>
                            <div className="bx--row">
                                <div className="bx--col-lg-12 bx--col-md-12 mainInformationPadding">
                                    {this.props.tabsLoading ? (
                                        <SkeletonText />
                                    ) : (
                                            <span className="font-small">
                                                {this.props.inspectionInfo.inspectionSection?.name}
                                            </span>
                                        )}
                                </div>
                            </div>
                        </div>
                        <div className="bx--col-lg-3 bx--col-md-2 mainInformationPadding">
                            <span className="bold">Inspection Type</span>
                            <div className="bx--row">
                                <div className="bx--col-lg-12 bx--col-md-12 mainInformationPadding">
                                    {this.props.tabsLoading ? (
                                        <SkeletonText />
                                    ) : (
                                            <span className="font-small">
                                                {this.props.inspectionInfo.inspectionType?.name}
                                            </span>
                                        )}
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </>
            </>
        );
    }


    render() {
        const isProjectAreaDisabled = this.props.inspectionInfo.idStatusReport != 1 || this.props.editingDisabledCheck;

        const validationsL = {
            startdate: this.validations.message('start date', this.props.inspectionInfo?.inspectionReport?.startDate, 'required'),
            enddate: this.validations.message('end date', this.props.inspectionInfo?.inspectionReport?.endDate, 'required'),
            projectArea: isProjectAreaDisabled ? false : this.validations.message('project area', this.props.inspectionInfo.projectArea, 'required')
          };

        return (
            <AppContext.Consumer>{
                ({ user }) =>
                    <>
                    {
            this.state.mainInformationOpened ? (
                <span className="mainInformationHeaderTitleExpanded">Main Information</span>
            ) : (
                    <div>
                         {this.renderLoadingModal()}
                        <Accordion>
                            <AccordionItem
                                onHeadingClick={this.onMainInformationAccordionClick}
                                className="mainInformationTitle"
                                title={this.renderMainInformationTitle()}
                            >
                                {!this.props.tabsLoading ? (
                                    <><Tile className="mainInformation--tile">
                                        <div className="bx--row">
                                            <div className="bx--col-lg-2 bx--col-md-2">Inspection code</div>
                                            <div className="bx--col-lg-10 bx--col-md-6">
                                                {this.props.inspectionInfo.inspectionCode}
                                            </div>
                                        </div>
                                    </Tile>
                                        <Tile className="mainInformation--tile">
                                            <div className="bx--row">
                                                {/* RITM0945977 */}
                                                {/* <div className="bx--col-lg-2 bx--col-md-2">Division</div> */}
                                                <div className="bx--col-lg-2 bx--col-md-2">Business Line</div>
                                                <div className="bx--col-lg-10 bx--col-md-6">
                                                    {this.props.inspectionInfo.division}
                                                </div>
                                            </div>
                                        </Tile>
                                        <Tile className="mainInformation--tile">
                                            <div className="bx--row">
                                                <div className="bx--col-lg-2 bx--col-md-2">Worksite</div>
                                                <div className="bx--col-lg-10 bx--col-md-6">
                                                    {this.props.inspectionInfo.workSite}
                                                </div>
                                            </div>
                                        </Tile>

                                        <Tile className="mainInformation--tile">
                                            <div className="bx--row">
                                                <div className="bx--col-lg-2 bx--col-md-2">Project</div>
                                                <div className="bx--col-lg-10 bx--col-md-6">
                                                    {this.props.inspectionInfo.project}
                                                </div>
                                            </div>
                                        </Tile>
                                        <Tile className="mainInformation--tile">
                                            <div className="bx--row">
                                                <div className="bx--col-lg-2 bx--col-md-2">Project Area*</div>
                                                    {isProjectAreaDisabled ? (
                                                        <div className="bx--col-lg-6">
														    {this.props.inspectionInfo.projectArea}                                                          
                                                        </div>
                                                        ) : (
                                                            <div className="bx--col-md-5 bx--col-xl-3">
                                                                <TextInput
                                                                    id="Project Area"
                                                                    type="text"
                                                                    labelText=""
                                                                    className="bx--text-input  "
                                                                    placeholder='Project Area'
                                                                    style={{ backgroundColor: "#fff" }}
                                                                    onChange={(e)=> this.props.onProjectAreaChange(e.target.value)}
                                                                    value={this.props.inspectionInfo.projectArea}
                                                                    invalid={validationsL.projectArea}
                                                                    invalidText="This field is Required!"
                                                                />
                                                            </div>
                                                        )
                                                    }
                                                
                                            </div>
                                        </Tile>
                                        
                                        <Tile className="mainInformation--tile">
                                            <div className="bx--row">
                                                <div className="bx--col-lg-2 bx--col-md-2">Inspection Section</div>
                                                <div className="bx--col-lg-10 bx--col-md-6">
                                                    {this.props.inspectionInfo.inspectionSection?.name}   
                                                </div>
                                            </div>
                                        </Tile>
                                        <Tile className="mainInformation--tile">
                                            <div className="bx--row">
                                                <div className="bx--col-lg-2 bx--col-md-2">Inspection Type</div>
                                                <div className="bx--col-lg-10 bx--col-md-6">
                                                    {this.props.inspectionInfo.inspectionType?.name}   
                                                </div>
                                            </div>
                                        </Tile> 
                                       
                                        <Tile className="mainInformation--tile">
                                            <div className="bx--row">
                                                <div className="bx--col-lg-6 bx--col-md-12">
                                                    <DatePicker
                                                        id="date-picker-startdate"
                                                        datePickerType="range"
                                                        dateFormat="d/m/Y"
                                                        onChange={this.onStartDateChange}
                                                        className="carbondatepicker"
                                                        light
                                                        locale="en"
                                                        disabled={this.props.editingDisabledCheck}
                                                    >
                                                         <DatePickerInput
                              id="date-picker-input-startDate"
                              labelText="Start Date*"
                              value={
                                this.props.inspectionInfo?.inspectionReport?.startDate
                                  ? moment( this.props.inspectionInfo.inspectionReport.startDate).format('DD/MM/Y')
                                  : ''
                              }
                              iconDescription="start date"
                              disabled={this.props.editingDisabledCheck }
                              invalid= {validationsL.startdate}
                            />
                            <DatePickerInput
                              id="date-picker-input-EndDate"
                              labelText="End Date*"
                              value={
                                this.props.inspectionInfo?.inspectionReport?.endDate
                                  ? moment(this.props.inspectionInfo.inspectionReport.endDate).format('DD/MM/Y')
                                  : ''
                              }
                              iconDescription="end date"
                              disabled={this.props.editingDisabledCheck || this.state.checkstartDate } 
                              invalid= {validationsL.enddate}
                            />
                                                    </DatePicker>
                                                    {validationsL.startdate}
                                                    {validationsL.enddate}
                                                </div>
                                            </div>
                                            <div className="bx--row">
                                            { !this.props.editingDisabledCheck&&
                                                <div className="bx--col-lg-12 bx--col-md-12 main-information-button">
                                                    <Button
                                                        size="default"
                                                        renderIcon={Save16}
                                                        kind="primary"
                                                        onClick={this.updateMainInformation}
                                                        disabled={this.state.editingDisabled}
                                                    >
                                                        Save
                                                 </Button>
                                                </div>
    }
                                            </div>
                                        </Tile>
                                       
                                    </>
                                ) : (
                                        <SkeletonText />
                                    )}
                            </AccordionItem>
                        </Accordion>


                    </div>


                )} </>
            }
            </AppContext.Consumer>);

    }
}








